module.exports = __webpack_public_path__ + "static/liquidglassicon-cfca255776ddc7e835bb68daa1529270.mp4";